const MailingList = `
  id
  createdAt
  description
  updatedAt
  subscribersCount
`;

export default MailingList;
